import { useState } from "react";

import styles from "./Tooltip.module.scss";

interface TooltipProps {
  content: string;
  children: React.ReactNode;
  delay?: number;
}

let timeout: number;

const Tooltip = ({ content, children, delay = 200 }: TooltipProps) => {
  const [active, setActive] = useState(false);

  const showTip = () => {
    timeout = window.setTimeout(() => {
      setActive(true);
    }, delay);
  };

  const hideTip = () => {
    clearInterval(timeout);
    setActive(false);
  };

  return (
    <div
      className={styles.tooltip}
      onMouseEnter={showTip}
      onMouseLeave={hideTip}
    >
      {children}
      {active && <div className={styles.content}>{content}</div>}
    </div>
  );
};

export default Tooltip;
